import './LeftSidebar.scss'
import { TabButton } from '../../platform/components/tab-button/TabButton';
import { ITabItem } from '../../platform/interfaces/tab-button';
import { useState } from 'react';
import { History } from '../history/History';
import { CurrentBets } from '../current-bets/CurrentBets';
import { gameStore, useTranslation } from '../../platform/stores';
import keno8Logo from '../../assets/images/keno-8-logo.png';
import keno10Logo from '../../assets/images/keno-10-logo.png';
import { observer } from 'mobx-react';

export const LeftSidebar = observer(() => {
  const t = useTranslation();
  const { gameId } = gameStore;
  const tabs: ITabItem[] = [
    {
      name: t('LEFT_SIDEBAR_CURRENT_BETS'),
      value: 1,
    },
    {
      name: t('LEFT_SIDEBAR_HISTORY'),
      value: 2,
    }
  ];
  const [tab, setTab] = useState(1);

  return (
    <div className="left-sidebar">
      <div className="logo">
        {
          gameId === 8
            ?
            <img src={keno8Logo} alt="Logo"/>
            :
            <img src={keno10Logo} alt="Logo"/>
        }
      </div>
      <div className="content">
        <TabButton tabs={tabs} onChange={(value) => setTab(value)}/>
        <div className="margin-top-10 tab-container">
          {
            tab === 1 ? <CurrentBets/> : <History/>
          }
        </div>
      </div>
    </div>
  );
});
